import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { loadArticle } from "../../../api/articles";

const ArticleDetails = () => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const articleId = searchParams.get("aid");

  useEffect(() => {

    if (articleId) {
      loadCurrentArticle(articleId);
    } else {
      console.error("No article ID found in URL");
      setLoading(false);
    }

  }, [articleId]);

  const loadCurrentArticle = async (articleId) => {
    
    try {
    
      const articleData = await loadArticle(articleId);
      setArticle(articleData);

    } catch (error) {

      console.error("Error fetching article details:", error);

    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }



  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  return (
    <>
      {/* =============== Blog area start =============== */}
      <div className="article-details blog-details-wrapper ">
      <p>{loading && ' - Chargement...'}</p>
        <div className="container position-relative pt-110">
          <div className="background-title">
            <h2>Détails article</h2>
          </div>
          { article && (
            <div className="row">
              <div className="col-lg-12">
                <div className="blog-details">
                  <div className="blog-d-top">
                    <h2 className="blog-d-title">
                      <Link onClick={scrollTop} to={"#"}>
                        {article.title}
                      </Link>
                    </h2>
                    <div className="blog-top-info">
                      {/* <Link
                        onClick={scrollTop}
                        to={"#"}
                        className="writer">
                        <i className="bi bi-person" /> {article.author}
                      </Link> */}
                      <Link
                        onClick={scrollTop}
                        to={"#"}
                        className="blog-date">
                        {" "}
                        <i className="bi bi-calendar2-week" />{" "}
                        <span>
                          {article.date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                        </span>
                      </Link>
                      <Link
                        onClick={scrollTop}
                        to={"#"}
                        className="blog-tag">
                        <i className="bi bi-list-task" /> {article.category}
                      </Link>
                    </div>
                    <div className="blog-d-thumb">
                      <img src={article.image} alt="Imgs"  />
                    </div>
                  </div>
                  <div className="blog-body">
                    {article.isExternal && article.sourceUrl ? (
                      <>
                        <p>Cet article provient d&apos;une source externe.</p>
                        <p>
                          <a href={article.sourceUrl} target="_blank" rel="noopener noreferrer">
                            Ouvrir la source originale
                          </a>
                        </p>
                      </>
                    ) : (
                      <p dangerouslySetInnerHTML={{ __html: article.description }}></p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* =============== Blog area end =============== */}
    </>
  );
};

export default ArticleDetails;
